import { APPROACH_PILLARS } from "@/data/content";
import BookingButton from "./BookingButton";

export default function Approach() {
  return (
    <section
      id="approach"
      className="py-28 lg:py-36 border-y grain"
      style={{ background: "var(--sano-bg-2)", borderColor: "var(--sano-border)" }}
      data-testid="approach-section"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 relative z-10">
        <div className="max-w-3xl mb-20">
          <div className="eyebrow mb-4">02 · Our Approach</div>
          <h2 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl leading-[1.05]">
            Healing begins when the body feels <em className="italic" style={{ color: "var(--sano-olive)" }}>safe</em>.
          </h2>
          <p className="mt-6 text-lg leading-relaxed" style={{ color: "var(--sano-ink-2)" }}>
            We weave together classical Chinese medicine and modern nervous-system
            science. Four pillars guide every session.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-y-16 gap-x-20">
          {APPROACH_PILLARS.map((p) => (
            <div
              key={p.n}
              className="border-l pl-8"
              style={{ borderColor: "var(--sano-olive)" }}
              data-testid={`approach-${p.n}`}
            >
              <div className="font-serif-display text-5xl mb-3" style={{ color: "var(--sano-olive)" }}>
                {p.n}
              </div>
              <h3 className="font-serif-display text-2xl mb-3">{p.title}</h3>
              <p className="text-sm leading-relaxed" style={{ color: "var(--sano-ink-2)" }}>
                {p.text}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-20 flex flex-wrap items-center gap-4">
          <BookingButton testid="approach-book-btn" />
          <span className="text-sm" style={{ color: "var(--sano-ink-2)" }}>
            Ready to begin? Reserve a time that works for you.
          </span>
        </div>
      </div>
    </section>
  );
}
